import { MainConcernValue } from '@cureskin/api-client/src/server-api/api';

export const MALE_HAIRFALL_STAGES_QUESTION_ID = 'MaleHairfallStages';
export const FEMALE_HAIRFALL_STAGES_QUESTION_ID = 'FemaleHairfallStages';

export const CONCERN_SPECIFIC_QUESTION_IDS: Readonly<Record<string, { Female: string[], Male: string[] }>> = {
  [MainConcernValue.HAIR_LOSS]: {
    Female: [FEMALE_HAIRFALL_STAGES_QUESTION_ID],
    Male: [MALE_HAIRFALL_STAGES_QUESTION_ID],
  },
};

export function getConcernSpecificQuestionCopy(): Readonly<Record<string, string>> {
  const selectHairfallStage = $localize`:@@selectYourHairfallStage:Select your Hairfall Stage`;
  return {
    [FEMALE_HAIRFALL_STAGES_QUESTION_ID]: selectHairfallStage,
    [MALE_HAIRFALL_STAGES_QUESTION_ID]: selectHairfallStage,
  };
}
